var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.consultandoElBack } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { "align-v": "end", offset: "0", "offset-lg": "6" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      placeholder: _vm.$t(
                        "apeironGwApp.alumnoSnp.acciones.buscar"
                      ),
                    },
                    model: {
                      value: _vm.filtroAlumnosPrograma,
                      callback: function ($$v) {
                        _vm.filtroAlumnosPrograma = $$v
                      },
                      expression: "filtroAlumnosPrograma",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.top",
                          value: _vm.$t(
                            "apeironGwApp.alumnoSnp.acciones.buscar"
                          ),
                          expression:
                            "$t('apeironGwApp.alumnoSnp.acciones.buscar')",
                          modifiers: { hover: true, top: true },
                        },
                      ],
                      staticClass: "mt-2",
                      attrs: { size: "sm", variant: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.buscarDesdePrimerPagina()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.alumnoSnp.acciones.buscar")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("b-icon", {
                        attrs: { icon: "search", variant: "primary" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.top",
                          value: _vm.$t(
                            "apeironGwApp.alumnoSnp.acciones.reset"
                          ),
                          expression:
                            "$t('apeironGwApp.alumnoSnp.acciones.reset')",
                          modifiers: { hover: true, top: true },
                        },
                      ],
                      staticClass: "mt-2",
                      attrs: { size: "sm", variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.reiniciarFiltros()
                        },
                      },
                    },
                    [
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("apeironGwApp.alumnoSnp.acciones.reset")
                          ),
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("b-icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.top",
                        value: _vm.$t("apeironGwApp.alumnoSnp.ayudaBuscador"),
                        expression:
                          "$t('apeironGwApp.alumnoSnp.ayudaBuscador')",
                        modifiers: { hover: true, top: true },
                      },
                    ],
                    staticClass: "float-right",
                    attrs: {
                      icon: "info-circle-fill",
                      variant: "success",
                      scale: "2",
                      animation: "fade",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                { staticClass: "area-responsive area-responsive-tabla" },
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      bordered: "",
                      small: "",
                      "thead-class": "custom-header",
                      items: _vm.alumnosPrograma,
                      fields: _vm.fieldsAlumnosPrograma,
                      "show-empty": "",
                      "empty-text": _vm.$t(
                        "apeironGwApp.alumnoSnp.tabla.sinRegistros"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(participante)",
                        fn: function (data) {
                          return [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  data.item.participante?.nombre
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("span"),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  data.item.participante?.apellidoPaterno
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("span"),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  data.item.participante?.apellidoMaterno
                                ),
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(acciones)",
                        fn: function (data) {
                          return [
                            _c(
                              "div",
                              { staticClass: "btn-group" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.top",
                                        value: _vm.$t(
                                          "apeironGwApp.alumnoSnp.acciones.ver"
                                        ),
                                        expression:
                                          "$t('apeironGwApp.alumnoSnp.acciones.ver')",
                                        modifiers: { hover: true, top: true },
                                      },
                                    ],
                                    attrs: { size: "sm", variant: "outline" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.mostrarModalDetalleAlumnoPrograma(
                                          data.item
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "exclamation-lg",
                                        variant: "primary",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("alumno-ligado", {
                                  attrs: {
                                    id: `alumno-ligado-${data.item.id}`,
                                    permisos: _vm.permisos,
                                    formModel: _vm.formModel,
                                    solicitud: _vm.solicitud,
                                    solucion: _vm.solucion,
                                    alumno: data.item,
                                    name: "ver-profesores",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.alumnoSnp.acciones.editar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.alumnoSnp.acciones.editar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editarAlumnoPrograma(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "pencil",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.esEscritura
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover.top",
                                            value: _vm.$t(
                                              "apeironGwApp.alumnoSnp.acciones.eliminar"
                                            ),
                                            expression:
                                              "$t('apeironGwApp.alumnoSnp.acciones.eliminar')",
                                            modifiers: {
                                              hover: true,
                                              top: true,
                                            },
                                          },
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              data.item.participante.tipoBeca
                                                .clave == "SIN_BECA" &&
                                              data.item.participante
                                                .estadoSolicitudBeca == null &&
                                              data.item.participante
                                                .numeroApoyo == null,
                                            expression:
                                              "\n                  data.item.participante.tipoBeca.clave == 'SIN_BECA' &&\n                  data.item.participante.estadoSolicitudBeca == null &&\n                  data.item.participante.numeroApoyo == null\n                ",
                                          },
                                        ],
                                        attrs: {
                                          size: "sm",
                                          variant: "outline",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.mostrarModalEliminarAlumnoPrograma(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "trash",
                                            variant: "primary",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.permiteVerHistoricos
                                  ? _c("consulta-legajos", {
                                      attrs: {
                                        area: "POSGRADOS",
                                        entidadesLegajo: [
                                          "SOLICITUD_POSGRADO_ALUMNOS",
                                        ],
                                        eventosLegajo: [
                                          "CREAR",
                                          "ACTUALIZAR",
                                          "ELIMINAR",
                                          "CLONAR",
                                        ],
                                        solicitudId: _vm.solicitud.id,
                                        participacionId: data.item.id,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "4" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              size: "sm",
                              id: "per-page-select",
                              options: _vm.pageOptions,
                            },
                            on: { change: _vm.buscarDesdePrimerPagina },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "pie-tabla mt-1", attrs: { md: "8" } },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.alumnoSnp.tabla.registrosPorPagina"
                                )
                              ),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      size: "sm",
                      "total-rows": _vm.registros,
                      "per-page": _vm.perPage,
                      align: "fill",
                      pills: "",
                    },
                    on: { change: _vm.cambiarPagina },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "text-right pie-tabla mt-1",
                  attrs: { md: "4" },
                },
                [
                  _c("span", {
                    domProps: { textContent: _vm._s(_vm.registros) },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "ml-1",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.alumnoSnp.tabla.totalDeRegistros")
                      ),
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        name: "modal-eliminar",
                        size:
                          (_vm.profesoresAsociados.length ?? 0) > 0
                            ? "xl"
                            : "md",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "modal-title",
                          fn: function () {
                            return [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.alumnoSnp.modal.tituloEliminar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "modal-footer",
                          fn: function () {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-3",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      !_vm.esEscritura || _vm.eliminando,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.eliminarAlumnoPrograma()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.alumnoSnp.acciones.eliminar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-3",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.mostrarModalEliminar = false
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.alumnoSnp.acciones.cerrar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.mostrarModalEliminar,
                        callback: function ($$v) {
                          _vm.mostrarModalEliminar = $$v
                        },
                        expression: "mostrarModalEliminar",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { staticClass: "d-block text-center" }, [
                            _c("h3", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "apeironGwApp.alumnoSnp.modal.detalleEliminar"
                                  )
                                ),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.profesoresAsociados.length > 0,
                              expression: "profesoresAsociados.length > 0",
                            },
                          ],
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "d-block text-center m-3" },
                            [
                              _c(
                                "b-alert",
                                { attrs: { show: "", variant: "warning" } },
                                [
                                  _c("h5", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.alumnoSnp.modal.alumnoRelacionadoEnNucleo"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.profesoresAsociados.length > 0,
                              expression: "profesoresAsociados.length > 0",
                            },
                          ],
                        },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  bordered: "",
                                  small: "",
                                  "thead-class": "custom-header",
                                  fields: _vm.fieldsProfesoresNucleo,
                                  items: _vm.profesoresAsociados,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "cell(participante)",
                                    fn: function (data) {
                                      return [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              data.item.participante?.nombre
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span"),
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              data.item.participante
                                                ?.apellidoPaterno
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span"),
                                        _vm._v(" "),
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              data.item.participante
                                                ?.apellidoMaterno
                                            ),
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "cell(relacion)",
                                    fn: function (data) {
                                      return _vm._l(
                                        data.item.profesorSnp.alumnos,
                                        function (alumno, index) {
                                          return _c("span", { key: index }, [
                                            _vm.alumnoProgramaSeleccionado
                                              .participante.cvu == alumno.cvu
                                              ? _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      alumno.relacion.nombre
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ])
                                        }
                                      )
                                    },
                                  },
                                  {
                                    key: "cell(relacionActiva)",
                                    fn: function (data) {
                                      return _vm._l(
                                        data.item.profesorSnp.alumnos,
                                        function (alumno, index) {
                                          return _c("span", { key: index }, [
                                            _vm.alumnoProgramaSeleccionado
                                              .participante.cvu == alumno.cvu
                                              ? _c(
                                                  "span",
                                                  [
                                                    alumno.asociado
                                                      ? _c("b-icon", {
                                                          attrs: {
                                                            icon: "check2-square",
                                                            variant: "success",
                                                            "font-scale": "2",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !alumno.asociado
                                                      ? _c("b-icon", {
                                                          attrs: {
                                                            icon: "square",
                                                            variant:
                                                              "secondary",
                                                            "font-scale": "2",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ])
                                        }
                                      )
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        name: "modal-detalle",
                        scrollable: "",
                        size: "xl",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "modal-title",
                          fn: function () {
                            return [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.alumnoSnp.modal.tituloDetalle"
                                    )
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "modal-footer",
                          fn: function () {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-3",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.mostrarModalDetalle = false
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.alumnoSnp.acciones.cerrar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.mostrarModalDetalle,
                        callback: function ($$v) {
                          _vm.mostrarModalDetalle = $$v
                        },
                        expression: "mostrarModalDetalle",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-tabs",
                                { staticClass: "m-1" },
                                [
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tab1"
                                          )
                                          .toString(),
                                        active: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "p-1" },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.cvuAlumno"
                                                        ),
                                                        "label-for":
                                                          "input-cvu",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-cvu",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.cvuAlumno"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante.cvu,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "cvu",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.cvu",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.curp"
                                                        ),
                                                        "label-for":
                                                          "input-curp",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-curp",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.curp"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .curp,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "curp",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.curp",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.nombreAlumno"
                                                        ),
                                                        "label-for":
                                                          "input-nombre-alumno",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-nombre-alumno",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.nombreAlumno"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .nombre,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "nombre",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.nombre",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.apellidoPaterno"
                                                        ),
                                                        "label-for":
                                                          "input-apellido-paterno",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-apellido-paterno",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.apellidoPaterno"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .apellidoPaterno,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "apellidoPaterno",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.apellidoPaterno",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.apellidoMaterno"
                                                        ),
                                                        "label-for":
                                                          "input-apellido-materno",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-apellido-materno",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.apellidoMaterno"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .apellidoMaterno,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "apellidoMaterno",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.apellidoMaterno",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.tipoBeca"
                                                        ),
                                                        "label-for":
                                                          "input-tipo-beca",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        attrs: {
                                                          disabled: "",
                                                          name: "input-tipo-beca",
                                                          options:
                                                            _vm.tiposBeca,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .tipoBeca,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "tipoBeca",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.tipoBeca",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.inicioGeneracion"
                                                        ),
                                                        "label-for":
                                                          "input-inicio-generacion",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-inicio-generacion",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.inicioGeneracion"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .inicioGeneracion,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "inicioGeneracion",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.inicioGeneracion",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.duracionMeses"
                                                        ),
                                                        "label-for":
                                                          "input-duracion-meses",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-duracion-meses",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.duracionMeses"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .duracionMeses,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "duracionMeses",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.duracionMeses",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.inicioEstudios"
                                                        ),
                                                        "label-for":
                                                          "input-inicio-estudios",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-inicio-estudios",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.inicioEstudios"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .inicioEstudios,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "inicioEstudios",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.inicioEstudios",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.finEstudios"
                                                        ),
                                                        "label-for":
                                                          "input-fin-estudios",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-fin-estudios",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.finEstudios"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .finEstudios,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "finEstudios",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.finEstudios",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    (_vm
                                                      .alumnoProgramaSeleccionado
                                                      .participante
                                                      .obtencionGrado?.length ??
                                                      0) > 0,
                                                  expression:
                                                    "(alumnoProgramaSeleccionado.participante.obtencionGrado?.length ?? 0) > 0",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.obtencionGrado"
                                                        ),
                                                        "label-for":
                                                          "input-obtencion-grado",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-obtencion-grado",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.obtencionGrado"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .obtencionGrado,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "obtencionGrado",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.obtencionGrado",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    (_vm
                                                      .alumnoProgramaSeleccionado
                                                      .participante
                                                      .obtencionGrado?.length ??
                                                      0) > 0,
                                                  expression:
                                                    "(alumnoProgramaSeleccionado.participante.obtencionGrado?.length ?? 0) > 0",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.acta"
                                                        ),
                                                        "label-for":
                                                          "input-acta",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          name: "input-acta",
                                                          options:
                                                            _vm.opcionesActa,
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.acta"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .acta,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "acta",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.acta",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.folioActa"
                                                          )
                                                          .toString(),
                                                        "label-for":
                                                          "input-folio-acta",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-folio-acta",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.folioActa"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .folioActa,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "folioActa",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.folioActa",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    (_vm
                                                      .alumnoProgramaSeleccionado
                                                      .participante
                                                      .obtencionGrado?.length ??
                                                      0) > 0,
                                                  expression:
                                                    "(alumnoProgramaSeleccionado.participante.obtencionGrado?.length ?? 0) > 0",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.opcionGraduacion"
                                                        ),
                                                        "label-for":
                                                          "input-opcion-graduacion",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          name: "input-opcion-graduacion",
                                                          options:
                                                            _vm.opcionesGraduacion,
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.opcionGraduacion"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .opcionGraduacion,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "opcionGraduacion",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.opcionGraduacion",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c("b-form-group", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "apeironGwApp.alumnoSnp.form.continuarAlGradoSuperior"
                                                      ),
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          ariaDescribedby,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "b-form-radio-group",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.opcionesRadios,
                                                                  "aria-describedby":
                                                                    ariaDescribedby,
                                                                  disabled: "",
                                                                  name: "input-continuar-al-grado-superior",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .alumnoProgramaSeleccionado
                                                                      .participante
                                                                      .continuarAlGradoSuperior,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .alumnoProgramaSeleccionado
                                                                          .participante,
                                                                        "continuarAlGradoSuperior",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "alumnoProgramaSeleccionado.participante.continuarAlGradoSuperior",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    (_vm
                                                      .alumnoProgramaSeleccionado
                                                      .participante.fechaBaja ??
                                                      "") != "",
                                                  expression:
                                                    "(alumnoProgramaSeleccionado.participante.fechaBaja ?? '') != ''",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.fechaBaja"
                                                        ),
                                                        "label-for":
                                                          "input-fecha-baja",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-fecha-baja",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.fechaBaja"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .fechaBaja,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "fechaBaja",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.fechaBaja",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    (_vm
                                                      .alumnoProgramaSeleccionado
                                                      .participante.fechaBaja ??
                                                      "") != "",
                                                  expression:
                                                    "(alumnoProgramaSeleccionado.participante.fechaBaja ?? '') != ''",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.reincorporacion"
                                                        ),
                                                        "label-for":
                                                          "input-fecha-reincorporacion",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-fecha-reincorporacion",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.reincorporacion"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .reincorporacion,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "reincorporacion",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.reincorporacion",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.motivoBaja"
                                                        ),
                                                        "label-for":
                                                          "input-motivo-baja",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          name: "input-motivo-baja",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.motivoBaja"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .motivoBaja,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "motivoBaja",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.motivoBaja",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.origenEstudiante"
                                                          )
                                                          .toString(),
                                                        "label-for":
                                                          "input-es-extranjero",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "b-form-checkbox",
                                                        {
                                                          attrs: {
                                                            id: "input-es-extranjero",
                                                            name: "input-es-extranjero",
                                                            value: true,
                                                            "unchecked-value": false,
                                                            disabled: "",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante
                                                                .esExtranjero,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .alumnoProgramaSeleccionado
                                                                  .participante,
                                                                "esExtranjero",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "alumnoProgramaSeleccionado.participante.esExtranjero",
                                                          },
                                                        },
                                                        [
                                                          _c("span", {
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  _vm
                                                                    .$t(
                                                                      "apeironGwApp.alumnoSnp.form.esExtranjero"
                                                                    )
                                                                    .toString()
                                                                ),
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    !_vm
                                                      .alumnoProgramaSeleccionado
                                                      .participante
                                                      .esExtranjero,
                                                  expression:
                                                    "!alumnoProgramaSeleccionado.participante.esExtranjero",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.entidadFederativa"
                                                          )
                                                          .toString(),
                                                        "label-for":
                                                          "input-entidad-federativa",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          disabled: "",
                                                          name: "input-entidad-federativa",
                                                          options:
                                                            _vm.entidadesFederativas,
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .entidadFederativa,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "entidadFederativa",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.entidadFederativa",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm
                                                          .$t(
                                                            "apeironGwApp.alumnoSnp.form.municipio"
                                                          )
                                                          .toString(),
                                                        "label-for":
                                                          "input-municipio",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          disabled: "",
                                                          name: "input-municipio",
                                                          options:
                                                            _vm.municipios,
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .municipio,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "municipio",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.municipio",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.institucion"
                                                        ),
                                                        "label-for":
                                                          "input-institucion",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          name: "input-institucion",
                                                          options:
                                                            _vm.instituciones,
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.institucion"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .institucion,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "institucion",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.institucion",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.sede"
                                                        ),
                                                        "label-for":
                                                          "input-sede",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          name: "input-sede",
                                                          options: _vm.sedes,
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.sede"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .sede,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "sede",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.sede",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        "label-size": "md",
                                                        label: _vm.$t(
                                                          "apeironGwApp.persona.participacion.becario.comprobanteEstudios"
                                                        ),
                                                        "label-for":
                                                          "input-comprobante-estudios",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "b-form-checkbox",
                                                        {
                                                          attrs: {
                                                            size: "md",
                                                            disabled: "",
                                                            name: "input-comprobante-estudios",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante
                                                                .comprobanteEstudios,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .alumnoProgramaSeleccionado
                                                                  .participante,
                                                                "comprobanteEstudios",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "alumnoProgramaSeleccionado.participante.comprobanteEstudios",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "apeironGwApp.persona.participacion.becario.comprobanteEstudiosDescripcion"
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        "label-size": "md",
                                                        label: _vm.$t(
                                                          "apeironGwApp.persona.participacion.becario.comprobanteNacionalidad"
                                                        ),
                                                        "label-for":
                                                          "input-comprobante-nacionalidad",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "b-form-checkbox",
                                                        {
                                                          attrs: {
                                                            size: "md",
                                                            disabled: "",
                                                            name: "input-comprobante-nacionalidad",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante
                                                                .comprobanteNacionalidad,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .alumnoProgramaSeleccionado
                                                                  .participante,
                                                                "comprobanteNacionalidad",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "alumnoProgramaSeleccionado.participante.comprobanteNacionalidad",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "apeironGwApp.persona.participacion.becario.comprobanteNacionalidadDescripcion"
                                                                )
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tab2"
                                          )
                                          .toString(),
                                      },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "p-1" },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _c("b-form-group", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "apeironGwApp.alumnoSnp.form.tieneProtocolo"
                                                      ),
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          ariaDescribedby,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "b-form-radio-group",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.opcionesRadios,
                                                                  "aria-describedby":
                                                                    ariaDescribedby,
                                                                  name: "input-comprobante-nacionalidad",
                                                                  disabled: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .alumnoProgramaSeleccionado
                                                                      .participante
                                                                      .tieneProtocolo,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .alumnoProgramaSeleccionado
                                                                          .participante,
                                                                        "tieneProtocolo",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "alumnoProgramaSeleccionado.participante.tieneProtocolo",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "8" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        "label-size": "md",
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.protocolo"
                                                        ),
                                                        "label-for":
                                                          "input-protocolo",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        attrs: {
                                                          name: "input-protocolo",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.protocolo"
                                                          ),
                                                          rows: "3",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .protocolo,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "protocolo",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.protocolo",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _c("b-form-group", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "apeironGwApp.alumnoSnp.form.tieneImpactoCientifico"
                                                      ),
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          ariaDescribedby,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "b-form-radio-group",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.opcionesRadios,
                                                                  "aria-describedby":
                                                                    ariaDescribedby,
                                                                  name: "input-tiene-impacto-cientifico",
                                                                  disabled: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .alumnoProgramaSeleccionado
                                                                      .participante
                                                                      .tieneImpactoCientifico,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .alumnoProgramaSeleccionado
                                                                          .participante,
                                                                        "tieneImpactoCientifico",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "alumnoProgramaSeleccionado.participante.tieneImpactoCientifico",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "8" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        "label-size": "md",
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.impactoCientifico"
                                                        ),
                                                        "label-for":
                                                          "input-impacto-cientifico",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        attrs: {
                                                          name: "input-impacto-cientifico",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.impactoCientifico"
                                                          ),
                                                          rows: "3",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .impactoCientifico,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "impactoCientifico",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.impactoCientifico",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _c("b-form-group", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "apeironGwApp.alumnoSnp.form.tieneImpactoSocial"
                                                      ),
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          ariaDescribedby,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "b-form-radio-group",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.opcionesRadios,
                                                                  "aria-describedby":
                                                                    ariaDescribedby,
                                                                  name: "input-tiene-impacto-social",
                                                                  disabled: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .alumnoProgramaSeleccionado
                                                                      .participante
                                                                      .tieneImpactoSocial,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .alumnoProgramaSeleccionado
                                                                          .participante,
                                                                        "tieneImpactoSocial",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "alumnoProgramaSeleccionado.participante.tieneImpactoSocial",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "8" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        "label-size": "md",
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.impactoSocial"
                                                        ),
                                                        "label-for":
                                                          "input-impacto-social",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        attrs: {
                                                          name: "input-impacto-social",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.impactoSocial"
                                                          ),
                                                          rows: "3",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .impactoSocial,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "impactoSocial",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.impactoSocial",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _c("b-form-group", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "apeironGwApp.alumnoSnp.form.tieneAportacionesSolucionProblemasPrioritarios"
                                                      ),
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          ariaDescribedby,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "b-form-radio-group",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.opcionesRadios,
                                                                  "aria-describedby":
                                                                    ariaDescribedby,
                                                                  name: "input-tiene-aportaciones-solucion-problemas-prioritarios",
                                                                  disabled: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .alumnoProgramaSeleccionado
                                                                      .participante
                                                                      .tieneAportacionesSolucionProblemasPrioritarios,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .alumnoProgramaSeleccionado
                                                                          .participante,
                                                                        "tieneAportacionesSolucionProblemasPrioritarios",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "alumnoProgramaSeleccionado.participante.tieneAportacionesSolucionProblemasPrioritarios",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "8" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        "label-size": "md",
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.aportacionesSolucionProblemasPrioritarios"
                                                        ),
                                                        "label-for":
                                                          "input-aportaciones-solucion-problemas-prioritarios",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        attrs: {
                                                          name: "input-aportaciones-solucion-problemas-prioritarios",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.aportacionesSolucionProblemasPrioritarios"
                                                          ),
                                                          rows: "3",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .aportacionesSolucionProblemasPrioritarios,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "aportacionesSolucionProblemasPrioritarios",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.aportacionesSolucionProblemasPrioritarios",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "4" } },
                                                [
                                                  _c("b-form-group", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "apeironGwApp.alumnoSnp.form.tieneEstrategiaAccesoUniversalConocimiento"
                                                      ),
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          ariaDescribedby,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "b-form-radio-group",
                                                              {
                                                                attrs: {
                                                                  name: "input-tiene-estrategia-acceso-universal-conocimiento",
                                                                  options:
                                                                    _vm.opcionesRadios,
                                                                  "aria-describedby":
                                                                    ariaDescribedby,
                                                                  disabled: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .alumnoProgramaSeleccionado
                                                                      .participante
                                                                      .tieneEstrategiaAccesoUniversalConocimiento,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .alumnoProgramaSeleccionado
                                                                          .participante,
                                                                        "tieneEstrategiaAccesoUniversalConocimiento",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "alumnoProgramaSeleccionado.participante.tieneEstrategiaAccesoUniversalConocimiento",
                                                                },
                                                              }
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ]),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                { attrs: { cols: "8" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        "label-size": "md",
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.estrategiaAccesoUniversalConocimiento"
                                                        ),
                                                        "label-for":
                                                          "input-estrategia-acceso-universal-conocimiento",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        attrs: {
                                                          name: "input-estrategia-acceso-universal-conocimiento",
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.estrategiaAccesoUniversalConocimiento"
                                                          ),
                                                          rows: "3",
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .estrategiaAccesoUniversalConocimiento,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "estrategiaAccesoUniversalConocimiento",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.estrategiaAccesoUniversalConocimiento",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tab",
                                    {
                                      attrs: {
                                        title: _vm
                                          .$t(
                                            "apeironGwApp.alumnoSnp.form.tab3"
                                          )
                                          .toString(),
                                      },
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "p-1" },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.trabaja"
                                                        ),
                                                        "label-for":
                                                          "input-trabaja",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          name: "input-trabaja",
                                                          options:
                                                            _vm.opcionesTrabaja,
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.trabaja"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .trabaja,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "trabaja",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.trabaja",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      staticClass: "mb-2",
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "apeironGwApp.alumnoSnp.form.empleadoEn"
                                                        ),
                                                        "label-for":
                                                          "input-empleado-en",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "resaltar-opciones-disabled",
                                                        attrs: {
                                                          name: "input-empleado-en",
                                                          options:
                                                            _vm.opcionesEmpleadoEn,
                                                          placeholder: _vm.$t(
                                                            "apeironGwApp.alumnoSnp.form.empleadoEn"
                                                          ),
                                                          disabled: "",
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "first",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "b-form-select-option",
                                                                  {
                                                                    attrs: {
                                                                      value:
                                                                        undefined,
                                                                      disabled:
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "apeironGwApp.alumnoSnp.form.seleccionarUno"
                                                                          )
                                                                          .toString()
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ]),
                                                        model: {
                                                          value:
                                                            _vm
                                                              .alumnoProgramaSeleccionado
                                                              .participante
                                                              .empleadoEn,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .alumnoProgramaSeleccionado
                                                                .participante,
                                                              "empleadoEn",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alumnoProgramaSeleccionado.participante.empleadoEn",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }